
import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';

interface ScannerErrorProps {
  errorMessage: string;
  onClose: () => void;
}

const ScannerError = ({ errorMessage, onClose }: ScannerErrorProps) => {
  return (
    <motion.div 
      className="p-6 bg-red-900/20 border border-red-700 rounded-md text-center max-w-xs mx-auto backdrop-blur-sm"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.1, duration: 0.3 }}
      >
        <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-3" />
      </motion.div>
      <h3 className="text-white font-bold text-lg mb-2">Lỗi quét mã</h3>
      <p className="text-red-200 mb-4">{errorMessage}</p>
      
      <div className="flex flex-col gap-2">
        <Button 
          variant="destructive"
          onClick={onClose}
          className="w-full"
        >
          Thử lại
        </Button>
        <Button 
          variant="outline"
          onClick={() => window.location.reload()}
          className="w-full border-red-700 text-red-200 hover:bg-red-950 hover:text-red-100"
        >
          Tải lại camera
        </Button>
      </div>
      
      <div className="mt-4 text-xs text-red-300 border-t border-red-800 pt-3">
        <p className="font-semibold mb-1">Mẹo khắc phục:</p>
        <ul className="text-left list-disc pl-5">
          <li>Đảm bảo mã QR nằm hoàn toàn trong khung</li>
          <li>Tăng độ sáng màn hình hiển thị mã QR</li>
          <li>Giữ điện thoại cách mã QR khoảng 15-20cm</li>
          <li>Đảm bảo mã QR không bị nhòe hoặc bị che</li>
        </ul>
      </div>
    </motion.div>
  );
};

export default ScannerError;
